import { Box } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import { API_GET_INVOICE } from '../../../Util/URLConstants';
import Loader from '../../../Components/Loader';
import { isEmpty } from '../../../Util/UtilHelper';
import axios from 'axios';
import NoInvoicePlaceholder from './NoInvoicePlaceholder';
import { align_center } from '../../../Styles/VMStyles';
import InvoicePlaceholder from './InvoicePlaceholder';

const InvoiceDetails = ({ customer, enquiry_id, events = [], navigate_from, refreshEnquiryDetails, readOnly = false }) => {
  const [state, setState] = useState({
    invoice_info: [],
    loading: false,
  });

  const fetchInvoiceDetails = useCallback(async () => {
    try {
      setState(prev => ({ ...prev, loading: true }));

      const response = await axios.get(API_GET_INVOICE, {
        params: { enquiry_id },
      });

      const resp = response.data;

      if (resp.status_code === 200) {
        console.log("resp:", resp);
        const invoiceDetails = resp?.invoice_info || [];
        setState(prev => ({
          ...prev,
          loading: false,
          invoice_info: invoiceDetails,
        }));
      } else {
        // toast.error(resp.message || 'Failed to fetch invoice details');
        setState(prev => ({ ...prev, loading: false }));
      }
    } catch (error) {
      console.error(error);
      // toast.error('Error fetching invoice details');
      setState(prev => ({ ...prev, loading: false }));
    }
  }, [enquiry_id]);

  useEffect(() => {
    if (!isEmpty(enquiry_id)) {
      fetchInvoiceDetails();
    }
  }, [enquiry_id, fetchInvoiceDetails]);

  const renderEmptyInvoice = () => {
    return <NoInvoicePlaceholder customer={customer} enquiry_id={enquiry_id} events={events} readOnly={readOnly} />;
  };

  const renderInvoiceData = () => {
    return <InvoicePlaceholder invoice_info={state.invoice_info} navigate_from={navigate_from} refreshEnquiryDetails={refreshEnquiryDetails} readOnly={readOnly}/>;
  };

  return (
    <Box
      sx={{
        // display: 'flex',
        // flexDirection: 'column',
        // alignItems: 'flex-end',
        // padding: '16px',
        // gap: '10px',
        // position: 'relative',
        // width: '866px',
        height: '330px',
        background: '#FFFFFF',
        ...align_center
      }}
    >
      {state.invoice_info.length === 0
        ? renderEmptyInvoice()
        : renderInvoiceData()
      }

      <Loader loading={state.loading} />
    </Box>
  );
};

export default InvoiceDetails;
